import { render, staticRenderFns } from "./SchemaManager.vue?vue&type=template&id=c12f513e&scoped=true&"
import script from "./SchemaManager.vue?vue&type=script&lang=ts&"
export * from "./SchemaManager.vue?vue&type=script&lang=ts&"
import style0 from "./SchemaManager.vue?vue&type=style&index=0&id=c12f513e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12f513e",
  null
  
)

export default component.exports